export default {
  errorTitle: {
    en: 'Operation Not Allowed',
    de: 'Vorgang nicht erlaubt',
    fr: 'Opération non autorisée',
    es: 'Operación no permitida',
    it: 'Operazione non consentita',
    nl: 'Bewerking niet toegestaan',
    no: 'Operasjon ikke tillatt',
    da: 'Handling ikke tilladt',
    sr: 'Operacija nije dozvoljena',
    pl: 'Operacja niedozwolona',
    sv: 'Åtgärden är inte tillåten'
  },
  successTitle: {
    en: 'Success',
    de: 'Erfolg',
    fr: 'Succès',
    es: 'Éxito',
    it: 'Successo',
    nl: 'Succes',
    no: 'Suksess',
    da: 'Succes',
    sr: 'Uspeh',
    pl: 'Sukces',
    sv: 'Framgång'
  },
  errorMessage: {
    en: 'The file operation failed',
    de: 'Der Dateioperation ist fehlgeschlagen',
    fr: 'L’opération sur les fichiers a échoué',
    es: 'La operación de archivos ha fallado',
    it: 'L’operazione sui file è fallita',
    nl: 'De bestandshandeling is mislukt',
    no: 'Filoperasjonen mislyktes',
    da: 'Filoperationen mislykkedes',
    sr: 'Operacija nad fajlovima nije uspela',
    pl: 'Operacja na plikach się nie powiodła',
    sv: 'Filåtgärden misslyckades'
  },
  forbiddenSharedMove: {
    en: 'Moving shared folders is forbidden',
    de: 'Das Verschieben freigegebener Ordner ist verboten',
    fr: 'Le déplacement de dossiers partagés est interdit',
    es: 'Está prohibido mover carpetas compartidas',
    it: 'Lo spostamento di cartelle condivise è vietato',
    nl: 'Het verplaatsen van gedeelde mappen is verboden',
    no: 'Flytting av delte mapper er forbudt',
    da: 'Flytning af delte mapper er forbudt',
    sr: 'Premeštanje deljenih fascikli je zabranjeno',
    pl: 'Przenoszenie współdzielonych folderów jest zabronione',
    sv: 'Att flytta delade mappar är inte tillåtet'
  },
  successMessage: {
    en: 'File successfully moved between storages',
    de: 'Datei erfolgreich zwischen Speichern verschoben',
    fr: 'Fichier déplacé avec succès entre les stockages',
    es: 'Archivo movido con éxito entre almacenamientos',
    it: 'File spostato con successo tra gli archivi',
    nl: 'Bestand succesvol verplaatst tussen opslagplaatsen',
    no: 'Fil flyttet vellykket mellom lagringer',
    da: 'Fil flyttet succesfuldt mellem lagre',
    sr: 'Datoteka uspešno premeštena između skladišta',
    pl: 'Plik pomyślnie przeniesiony między magazynami',
    sv: 'Fil flyttades framgångsrikt mellan lagringsutrymmen'
  }
};